// In-app notification inbox (ticket 2.8.1): the calls the bell, the panel and the Notifications page make.
// Every call is for the signed-in user's own notices; the server answers 403 for someone else's.

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

const getToken = () => sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

async function request(path, { method = "GET", signal, body } = {}) {
  const token = getToken();
  if (!token) {
    const err = new Error("Please sign in to see your notifications.");
    err.status = 401;
    throw err;
  }
  const response = await fetch(`${API_BASE_URL}/notification${path}`, {
    method,
    headers: { "Content-Type": "application/json", token },
    signal,
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  let data = null;
  try {
    data = await response.json();
  } catch (e) {
    data = null;
  }
  if (!response.ok || !data || data.success === false) {
    const err = new Error((data && data.message) || `Request failed (${response.status})`);
    err.status = response.status;
    throw err;
  }
  return data.result;
}

export const FILTERS = [
  { id: "all", label: "All" },
  { id: "unread", label: "Unread" },
  { id: "licences", label: "Licences" },
  { id: "rights", label: "Rights" },
  { id: "wallet", label: "Wallet" },
  { id: "account", label: "Account" },
];

export const listInbox = ({ filter = "all", limit = 20, cursor = null, signal } = {}) => {
  const query = new URLSearchParams({ filter, limit: String(limit) });
  if (cursor) query.set("cursor", cursor);
  return request(`/inbox?${query.toString()}`, { signal });
};

export const getUnreadCount = (signal) => request("/inbox/count", { signal });
export const markRead = (id) => request(`/inbox/${id}/read`, { method: "PATCH" });
export const markUnread = (id) => request(`/inbox/${id}/unread`, { method: "PATCH" });
export const markAllRead = () => request("/inbox/read_all", { method: "PATCH" });
export const dismissNotice = (id) => request(`/inbox/${id}/dismiss`, { method: "PATCH" });
export const resolveNotice = (id) => request(`/inbox/${id}/resolve`);

// Notification preferences (FSD 6.9.1): per category switches for In-app / Email / Push. Legal notices come back locked.
export const getMusicPreferences = (signal) => request("/music-preferences", { signal });
export const saveMusicPreferences = (preferences) => request("/music-preferences", { method: "PUT", body: { preferences } });
